export default class Component {
    constructor(parentNode, tagName = 'div', className = '', content = '') {
        const element = document.createElement(tagName);
        element.className = className;
        element.textContent = content;
        parentNode === null || parentNode === void 0 ? void 0 : parentNode.append(element);
        this.node = element;
    }
    destroy() {
        this.node.remove();
    }
}
